import React, { useCallback } from 'react';
import classNames from 'classnames';

import { APP_LANGUAGES } from 'src/constants';

import './languageSelect.scss';

export const LanguageSelect = ({ language, setLanguage = () => {} }) => {
  const onSelect = useCallback(
    (lng) => () => {
      setLanguage(lng);
    },
    [setLanguage],
  );

  return (
    <div className="language-select">
      {APP_LANGUAGES.map((item) => {
        const itemClasses = classNames('language-select__item', {
          'language-select__item--selected': item.id === language,
          'language-select__item--deselected': item.id !== language,
        });

        return (
          <div key={item.id} className={itemClasses} onClick={onSelect(item.id)}>
            {item?.language?.toUpperCase()}
          </div>
        );
      })}
    </div>
  );
};
